module.exports = { baseApiUrl: '/api', environment: 'prod' };
